import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Contact from './components/Contact';
import Homepage from './components/Homepage';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import Blogs from './components/Blogs';
import Faq from './components/Faq';
import BulkModules from './components/BulkModules';
import PremiumSMS from './components/PremiumSMS';
import USSDcode from './components/USSDcodes';
import ChatBots from './components/ChatBots';
import UZA from './components/UZA';
import SchoolSystem from './components/SchoolSystem';
import PaymentsMethods from './components/PaymentsMethods';
import SoftDev from './components/SoftDev';
import RegForm from './components/RegForm';
import Login from './components/Login';
import DeveloperResources from './components/DevResources';
import GamingService from './components/Gaming';
import EmailService from './components/EmailService';
import Pricing from './components/Pricing';
import BlogsComponent, { BlogPost } from './BlogsComponent'; // ← only new line needed
import ScrollToTop from './components/ScrollToTop';

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-E6HMD3QLXE', {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AnalyticsTracker />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/blog" element={<Blogs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/bulk-sms-modules" element={<BulkModules />} />
          <Route path="/premium-sms" element={<PremiumSMS />} />
          <Route path="/ussd-services" element={<USSDcode />} />
          <Route path="/chat-bots" element={<ChatBots />} />
          <Route path="/stock-management" element={<UZA />} />
          <Route path="/school-management" element={<SchoolSystem />} />
          <Route path="/payment-methods" element={<PaymentsMethods />} />
          <Route path="/software-development" element={<SoftDev />} />
          <Route path="/register" element={<RegForm />} />
          <Route path="/login" element={<Login />} />
          <Route path="/developer-resources" element={<DeveloperResources />} />
          <Route path="/gaming-service" element={<GamingService />} />
          <Route path="/email-service" element={<EmailService />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/blogs" element={<BlogsComponent />} />         {/* ← new */}
          <Route path="/blogs/:slug" element={<BlogPost />} />         {/* ← new */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;